import { border, color, flexbox, layout, position, space } from "styled-system";

import { isTouch } from "../core-modules/utils";
import styled from "styled-components";

const Button = styled.button`
  ${color}
  ${space}
  ${border}
  ${flexbox}
  ${layout}
  ${position}
  ${(props) => {
    if (props.underlineRollover && !isTouch()) {
      return `
      position: relative;
      &::after {
        background-color: ${props.theme.colors.foreground};
        content: "";
        height: 1px;
        opacity: 0;
        position: absolute;
        transition: opacity 200ms;
        width: 100%;
        bottom: 0;
        left: 0;
      }
        :hover {
          &::after {
            opacity: 1;
          }
        }
      `;
    }
    if (props.disabled) {
      return "cursor: default;";
    }
  }}
`;

Button.defaultProps = {
  color: "foreground",
  underlineRollover: false,
};

export default Button;
